import {Dish} from './Dish';
import {SignIn} from './SignIn';
import {Search} from './Search';
import {SignUp} from './SignUp';
import {Filter} from './Filter';
import {Reviews} from './Reviews';
import {MenuList} from './MenuList';
import {Checkout} from './Checkout';
import {Onboarding} from './Onboarding';
import {Promocodes} from './Promocodes';
import {EditProfile} from './EditProfile';
import {NewPassword} from './NewPassword';
import {OrderFailed} from './OrderFailed';
import {LeaveAReview} from './LeaveAReview';
import {OrderHistory} from './OrderHistory';
import {TrackYourOrder} from './TrackYourOrder';
import {ForgotPassword} from './ForgotPassword';
import {OrderSuccessful} from './OrderSuccessful';
import {PromocodesEmpty} from './PromocodesEmpty';
import {ConfirmationCode} from './ConfirmationCode';
import {OrderHistoryEmpty} from './OrderHistoryEmpty';
import {SignUpAccountCreated} from './SignUpAccountCreated';
import {VerifyYourPhoneNumber} from './VerifyYourPhoneNumber';
import {ForgotPasswordSentEmail} from './ForgotPasswordSentEmail';

import {Activities} from './Activities';
import {Partners} from './Partners';
import {Articles} from './Articles';
import {MySons} from './MySons';
import {ExtraCurricular} from './ExtraCurricular';
import {Academy} from './tabs/Academy';
import {History} from './tabs/History';
import {DetailActivities} from './DetailActivities';
import {DetailArticles} from './DetailArticles';
import {DetailExtraCurriculars} from './DetailExtraCurriculars';
import {DetailPartners} from './DetailPartners';
import {DetailSons} from './DetailSons';
import {DetailSonsSubjects} from './DetailSonsSubjects';
import {DetailSonsRaport} from './DetailSonsRaport';
import {DetailSonsRkh} from './DetailSonsRkh';
import { DetailSonsAbsensi } from './DetailSonsAbsensi';
import { DetailSonsGradeAnalysis } from './DetailSonsGradeAnalysis';
import { Creation } from './Creation';
import {DetailCreation} from './DetailCreation';
import {DetailAcademy} from './DetailAcademy';
import { ClockInSuccess } from './ClockInSuccess';

export const screens = {
  Dish,
  SignIn,
  Search,
  SignUp,
  Filter,
  Reviews,
  MenuList,
  Checkout,
  Onboarding,
  Promocodes,
  EditProfile,
  OrderFailed,
  NewPassword,
  LeaveAReview,
  OrderHistory,
  ForgotPassword,
  TrackYourOrder,
  OrderSuccessful,
  PromocodesEmpty,
  ConfirmationCode,
  OrderHistoryEmpty,
  SignUpAccountCreated,
  VerifyYourPhoneNumber,
  ForgotPasswordSentEmail,
  Activities,
  Partners,
  Articles,
  MySons,
  ExtraCurricular,
  Academy,
  History,
  DetailActivities,
  DetailArticles,
  DetailExtraCurriculars,
  DetailPartners,
  DetailSons,
  DetailSonsSubjects,
  DetailSonsRaport,
  DetailSonsRkh,
  DetailSonsAbsensi,
  DetailSonsGradeAnalysis,
  Creation,
  DetailCreation,
  DetailAcademy,
  ClockInSuccess
};
